<template>
    <div>
        <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="close">
            <a-checkbox v-model="checkAll" @change="handleCheckAllChange">
                全选
            </a-checkbox>
            <a-tree
                v-model="formData.ids"
                checkable
                :expanded-keys="expandedKeys"
                :auto-expand-parent="autoExpandParent"
                :replaceFields="replaceFields"
                :selected-keys="selectedKeys"
                :tree-data="category_list"
                @expand="onExpand"
                @check="onCheck"
            />
            <div class="drawer-btn">
                <a-button type="primary" @click="handleSubmit" :style="{ marginRight: '8px' }">
                    确定
                </a-button>
                <a-button @click="close">
                    取消
                </a-button>
            </div>
        </a-drawer>
    </div>
</template>

<script>
import {drawerConfig} from "@/utils/utils"
import API from "./api";

export default {
    name: "modulePermissionsSet",
    props: [],
    data() {
        return {
            drawerConfig,
            title: '模块权限设置',
            visible: false,
            category_list: [],
            checkAll: false,
            replaceFields: {children: 'children', title: 'name', key: 'id'},
            expandedKeys: [],
            autoExpandParent: true,
            selectedKeys: [],
            ids: [],
            idsArr: [],
            formData: {
                role_id: "",
                ids: []
            }
        };
    },
    watch: {},
    mounted() {
    },
    methods: {
        handleSubmit() {
            let _this = this;
            API.service.MODULE_SET_POST(this.formData).then(res => {
                if (res.data.code == 200) {
                    this.$message.success({content: res.data.msg, duration: 2})
                    this.close()
                    this.$emit("submitSuccess");
                } else if (res.data.code == 400) {
                    res.data.msg.map((item) => {
                        _this.formErr[item.field] = item.msg
                    })
                }
            })
        },
        getInfo(data) {
            API.service.MODULE_SET({
                role_id: data.id,
            }).then(res => {
                if (res.data.code == 1) {
                    this.category_list = res.data.data.category_list;
                    this.ids = res.data.data.category_list.map((item) => {
                        return item.id;
                    });
                    let role_id = res.data.data.role_info.id
                    this.formData = {
                        role_id: role_id,
                        ids: res.data.data.checked_ids,
                    }
                    this.getCheckAllStatus()
                }
            })
        },
        handleCheckAllChange() {
            if (this.checkAll) {
                this.formData.ids = this.ids
            } else {
                this.formData.ids = []
            }
        },
        onExpand(expandedKeys) {
            this.expandedKeys = expandedKeys;
            this.autoExpandParent = false;
        },
        getCheckAllStatus() {
            if (this.formData.ids.length == this.ids.length) {
                this.checkAll = true
            } else {
                this.checkAll = false
            }
        },
        onCheck(checkedKeys, e) {
            this.idsArr = [...checkedKeys, ...e.halfCheckedKeys]
            this.formData.ids = checkedKeys;
            this.getCheckAllStatus()
        },
        open(data) {
            this.visible = true;
            this.getInfo(data)
        },
        close() {
            this.visible = false;
            this.formData = {
                role_id: "",
                ids: []
            }
        }
    },
}
</script>

<style scoped>

</style>
